import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CalculationInfoIcon } from "../accounting/CalculationInfoIcon";
import { CalculationGuideDialog } from "../accounting/CalculationGuideDialog";

export function HseFieldInfoLabel({ label, infoTitle, infoBody, htmlFor }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const text = typeof label === "string" && label.includes(".") ? t(label) : label;

  return (
    <>
      <span className="inline-flex items-center gap-1">
        {htmlFor ? (
          <label htmlFor={htmlFor} className="text-sm font-medium text-slate-700">
            {text}
          </label>
        ) : (
          <span className="text-sm font-medium text-slate-700">{text}</span>
        )}
        {infoTitle ? (
          <CalculationInfoIcon
            onClick={() => setOpen(true)}
            ariaLabel={t(infoTitle)}
          />
        ) : null}
      </span>
      <CalculationGuideDialog
        open={open}
        onClose={() => setOpen(false)}
        titleKey={infoTitle}
        bodyKey={infoBody}
      />
    </>
  );
}
